import React from "react";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const FeedbackCard = ({ authData }: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();

    return (
        <React.Fragment>
            {i18nLang && i18nLang.language === "en" && (
                <div className="box box-border-top">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon position-right" aria-hidden="true">
                                <RenderIcons iconName="question" />
                            </div>
                            <div className="box-title-text">
                                <h3 className="box-title">{tLang("dashboard.feedBackWidget.title")}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="box-content">
                        <p>{tLang("dashboard.feedBackWidget.message")}</p>
                        <p className="text-align-center">
                            <a
                                className="btn-default btn-secondary-outline bit-btn"
                                id="btn-leave-feedback"
                                target="_blank"
                                rel="noreferrer"
                                href={authData.isIDFUser ? "https://www.surveymonkey.com/r/IDFmemfeedback" : "https://www.surveymonkey.com/r/YMZQJYJ"}
                                onClick={() => window.addToDataLayer({ event: "Footer Feedback Link" })}
                            >
                                <span className="btn-text">{tLang("dashboard.feedBackWidget.buttonText")}</span>
                            </a>
                        </p>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default FeedbackCard;
